import { observer } from 'mobx-react';
import React from 'react';
import { Instance } from 'mobx-state-tree';
import { IItemRendererProps, Select } from '@blueprintjs/select';
import { TLCode } from '../../../common/enums';
import { toJS } from 'mobx';
import { Button, MenuItem } from '@blueprintjs/core';
import withTranslate, { WithTranslateProps } from '../WithTranslate';
import { TranslatedMessage } from '../translation';
import { Group } from '../../../store/models/Group';
import { CROSS } from '@blueprintjs/icons/lib/esm/generated/iconNames';

interface GroupSelectionProps extends WithTranslateProps {
  groupList: Array<Instance<typeof Group>>;
  onChange?: (group: Instance<typeof Group>) => void;
  selectedGroupId?: number;
  getGroupById: (id: number) => Instance<typeof Group>;
  allowEmpty: boolean;
}

@observer
class GroupSelection extends React.Component<GroupSelectionProps> {
  onSelect = async (value) => {
    if (this.props.onChange !== null && this.props.onChange !== undefined) {
      this.props.onChange!(value!);
    }
  };

  get TypedSelectInput() {
    return Select.ofType<Instance<typeof Group>>();
  }

  renderGroupMenuItem(item: Instance<typeof Group>, { handleClick, index, modifiers }: IItemRendererProps) {
    if (modifiers.matchesPredicate) {
      return <MenuItem key={`group-${index}`} active={modifiers.active} onClick={handleClick} text={item.name!} />;
    } else {
      return null;
    }
  }

  filterGroup = (query, group) => {
    return group.name!.toLowerCase().indexOf(query.toLowerCase()) >= 0;
  };

  render() {
    const { selectedGroupId, groupList, getGroupById, allowEmpty } = this.props;
    const selectedGroup = selectedGroupId ? getGroupById(selectedGroupId) : null;

    const TypedSelectInput = this.TypedSelectInput;
    return (
      <div>
        <TypedSelectInput
          onItemSelect={(item) => {
            this.onSelect(item);
          }}
          items={toJS(groupList)}
          itemRenderer={this.renderGroupMenuItem}
          itemPredicate={this.filterGroup}
          popoverProps={{ minimal: true }}
        >
          <Button
            rightIcon="caret-down"
            text={selectedGroup ? selectedGroup.name! : <TranslatedMessage id={TLCode.CHOOSE_A_GROUP} />}
          />
          {allowEmpty && selectedGroup && (
            <Button
              minimal
              icon={CROSS}
              onClick={() => this.onSelect({ groupId: undefined, name: 'Select an element' })}
            />
          )}
        </TypedSelectInput>
      </div>
    );
  }
}

export default withTranslate(GroupSelection);
